import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { forkJoin } from 'rxjs';

import { PublicationNode } from '../../../../publication/publication';
import { PublicationService } from '../../../../publication/publication.service';
import { TemplateService } from '../../../service/template.service';

interface ParaChecklistItem {
  node: PublicationNode;
  selected: boolean;
}

@Component({
  selector: 'app-paragraph-checklist',
  templateUrl: './paragraph-checklist.component.html',
  styleUrls: ['./paragraph-checklist.component.css'],
  standalone: false
})
export class ParagraphChecklistComponent implements OnChanges {
  @Input() rbSectKey: number;
  @Input() csskey: number;
  @Input() appkey: number;
  @Input() editable: boolean;

  items: ParaChecklistItem[] = [];
  isLoading = false;
  // Expanded by default; the user can collapse the paragraph rows (keeping just the
  // header visible) to focus on the section applicability questions above.
  rowsVisible = true;
  private loadedRbSectKey: number = null;

  constructor(
    private publicationService: PublicationService,
    private templateService: TemplateService
  ) {}

  // The section this checklist belongs to only ever gets revealed once its own answer
  // is 'Y', so load once (per rbSectKey) rather than re-fetching on every change tick.
  ngOnChanges(changes: SimpleChanges) {
    if (this.rbSectKey && this.rbSectKey !== this.loadedRbSectKey) {
      this.loadedRbSectKey = this.rbSectKey;
      this.load();
    }
  }

  load() {
    this.isLoading = true;
    forkJoin({
      paragraphs: this.publicationService.getParagraphsForSection(this.rbSectKey),
      exclusions: this.templateService.getParaExclusions(this.csskey, this.appkey),
    }).subscribe(
      ({ paragraphs, exclusions }) => {
        this.items = (paragraphs || []).map((node) => ({
          node: { ...node, name: this.templateService.decodeHtml(node.name) },
          selected: !exclusions.includes(node.id),
        }));
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  onToggle(item: ParaChecklistItem) {
    item.selected = !item.selected;
    this.templateService
      .setParaApplicability(this.csskey, this.appkey, item.node.id, item.selected)
      .subscribe();
  }

  toggleRowsVisible() {
    this.rowsVisible = !this.rowsVisible;
  }

  hasAnyUnchecked(): boolean {
    return this.items.some((item) => !item.selected);
  }
}
